import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import FlightSearch from "./FlightSearch";
import ReviewList from "./ReviewList";
import PhotosContainer from "./PhotosContainer";

const DestinationDetails = ({user, handleAddFavorite, favoriteList}) => {
    
    const [destination, setDestination] = useState(null)
    const [isLoaded, setIsLoaded] = useState(false)
    const [favorite, setFavorite] = useState(false)
    const [toggleSearch, setToggleSearch] = useState(false)

    const {id} = useParams()

    const handleSetFavorite = (newFavorite) => {
        setFavorite(favorite => !favorite)
        handleAddFavorite(newFavorite)
    }
    
    const handleToggleSearch = () => {
        setToggleSearch(prev => !prev)
    }

    useEffect(() => {
        fetch(`https://travelatr.herokuapp.com/destinations/${id}`)
        .then(r => r.json())
        .then((destination) => {
            const initialFav = favoriteList.find((fav) => {
                    return fav.destination.id === parseInt(id)
                })
            if (initialFav) {
                 setFavorite(true)
                } else {
                 setFavorite(false)
                }
            setDestination(destination)
            setIsLoaded(true)
        })
    }, [id, favoriteList])

    if (!isLoaded) return <h2 className="loading">Loading...</h2>;
    
    const { name, image, description, us, airport_code, photos, rating, reviews, user_ratings_total, likes } = destination
    
    const handleLikeClick = () => {
        fetch("https://travelatr.herokuapp.com/likes", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ user_id: user.id, destination_id: id })
        })
        .then(r => r.json())
        .then(destination => {
            setDestination(destination)
            console.log(destination)
        })
    }

    const handleFavoriteClick = () => {
        fetch("https://travelatr.herokuapp.com/favorites", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify( { user_id: user.id, destination_id: id } )
        })
        .then(r => r.json())
        .then((newFavorite) => {
            handleSetFavorite(newFavorite)})
    }

    return(
    <div className="details-box">
        <div className="img-details">
            <img src={image} alt={name}/>
        </div>
        <div className="destination-details">
            <h3>{name}</h3>
            <p>{description}</p>
            <h4>{us ? "Domestic" : "International"}</h4>
            <h5>Airport code: {airport_code}</h5>
            <span className="like-btn" onClick={handleLikeClick}>♥ <strong>{likes.length} Likes</strong></span>
            <button className="fav-btn" onClick={handleFavoriteClick}>{favorite ? "Added" : "Add"} to favorites</button>
        </div>
        <div> 
            <button className="flight-button more" onClick={handleToggleSearch}>{toggleSearch ? "Hide" : "Show"} Flight Search </button>
            {toggleSearch && <FlightSearch toggleSearch={toggleSearch} name={name}/> }
        </div>
        <div className="review-details">
            <span style={{display: rating ? "block" : "none" }}>
                <p>{rating}</p>
                <p>{reviews ? <ReviewList reviews={reviews} /> : null }</p>
                <p>{user_ratings_total} reviews </p>
            </span>
        </div>
            <PhotosContainer photos={photos} />
    </div>
    )
}

export default DestinationDetails;